module.exports = __webpack_public_path__ + "img/logo.b368a918.png";